import type { GlobalConfig } from '@repo/go-ui';
import { Button, createNotification } from '@repo/go-ui';
import type { i18n } from 'i18next';

import type { GoStorageObject } from '../../../shared/api/IDashboardService';
import modalBox from '../../../shared/components/ModalBox/modalBox';
import styles from '../AlertRulesTable.module.css';
import type { AlertRulesTemplatesManager, TAlertRulesTemplateData } from '../services/AlertRulesTemplatesManager';

export function openDeleteTemplateModal(
  template: GoStorageObject<TAlertRulesTemplateData>,
  templateManager: AlertRulesTemplatesManager,
  configProvider: GlobalConfig,
  i18n: i18n,
) {
  modalBox({
    configProvider,
    modalBody: (close) => (
      <div style={{ width: 440 }}>
        <div className={styles.modalTitle}>
          {i18n.t('alertsManagerWidget:alertRules.templatesDrawer.deleteTemplate')}
        </div>
        <div className={styles.modalDescription}>
          {i18n.t('alertsManagerWidget:alertRules.templatesDrawer.deleteTemplateDescription')}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <Button variant="primary" onClick={() => close('cancel')}>
            {i18n.t('alertsManagerWidget:alertRules.templatesDrawer.cancel')}
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              templateManager
                .deleteTemplate(template.id)
                .then(() => {
                  close('ok');
                })
                .catch((e) => {
                  createNotification({
                    title: 'Error',
                    text: e.name,
                    type: 'error',
                  });
                });
            }}
          >
            {i18n.t('alertsManagerWidget:alertRules.templatesDrawer.delete')}
          </Button>
        </div>
      </div>
    ),
  });
}
